<svg
  *ngIf="id !== 'transparent'"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 100 134"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="100" height="133.333" rx="10" [attr.fill]="color" />
</svg>

<svg
  *ngIf="id === 'transparent'"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 100 134"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="100" height="133.333" rx="10" fill="#F6FDFF" />
  <mask id="mask0_89_835" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="100" height="134">
    <rect width="100" height="133.333" rx="10" fill="#44F2C4" />
  </mask>
  <g mask="url(#mask0_89_835)">
    <rect width="20.9093" height="149.582" transform="matrix(0.6 0.8 -0.6 0.8 61 -40)" fill="#CEE0E5" />
    <rect
      width="21.63"
      height="154.738"
      transform="matrix(0.592312 0.805709 -0.592312 0.805709 79.1523 -14.9087)"
      fill="#CEE0E5"
    />
    <rect
      width="21.63"
      height="154.738"
      transform="matrix(0.592312 0.805709 -0.592312 0.805709 98.3701 11.2324)"
      fill="#CEE0E5"
    />
    <rect width="20.9093" height="149.582" transform="matrix(0.6 0.8 -0.6 0.8 117.455 35.2734)" fill="#CEE0E5" />
  </g>
</svg>
